import { cliente } from '@/lib/cliente';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSincronizarPagos() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => cliente.vencimientos.sincronizar(),
    onSettled: () => {
      // También tras un error: un sync que falla a medias (o uno concurrente) pudo dejar la base
      // actualizada igual, y sin refetch la pantalla seguía mostrando saldos viejos.
      queryClient.invalidateQueries({ queryKey: ['propuestas-pago'] });
      queryClient.invalidateQueries({ queryKey: ['vencimientos-detalle'] });
      // La sincronización también crea en la app los proveedores nuevos de BC.
      queryClient.invalidateQueries({ queryKey: ['proveedores'] });
      queryClient.invalidateQueries({ queryKey: ['bc-vendors'] });
    },
  });
}
